import s from './QuickBookingRestCard.module.sass'

import { FC } from 'react'

import { QuickBookingSlots } from '@widgets/Restaurant/QuickBooking/components/QuickBookingSlots'
import { useNearestSlots } from '@widgets/Restaurant/QuickBooking/helpers/useNearestSlots'
import { resolveQuickBookingTitle } from '@widgets/Restaurant/QuickBooking/helpers/resolveQuickBookingTitle'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Text } from '@shared/ui/Typography/Text'
import { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'

import PopupArrow from '@icons/icon--popup-arrow.svg'

interface Props {
  restData: TypeMappingRestOutput
  className?: string
  onClickSlot?: (data: TypeMappingRestOutput) => void
  onClickDots?: (data: TypeMappingRestOutput) => void
}

const QuickBookingRestCard: FC<Props> = ({ restData, className = '', onClickSlot, onClickDots }) => {
  const slotsData = useNearestSlots({
    restData: restData,
    guests: 2,
  })

  slotsData.slots = slotsData.slots.slice(0, 3)

  const getTitle = () => {
    if (!slotsData?.slots?.length) return `Забронировать стол ... :`
    const nearSlot = slotsData.slots[0]

    const nearSlotIsToday =
      new Date(nearSlot.day.value).toLocaleDateString() === new Date(Date.now()).toLocaleDateString()

    const tailDate = resolveQuickBookingTitle({ day: nearSlot.day, isToday: nearSlotIsToday, variant: 'card' })

    return `Забронировать стол на ${tailDate}:`
  }

  const handleClickComponent = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <BlockBoundary>
      <div className={`${s.wrapper} ${className}`} onClick={handleClickComponent}>
        <PopupArrow className={s.arrow} />
        <Text sizes={'S'} className={s.title}>
          {getTitle()}
        </Text>
        <QuickBookingSlots
          slotsData={slotsData}
          classNameWrapper={`${s.schedule} ${className}`}
          restData={restData}
          classNameSlot={s.slot}
          classNameDots={s.dots}
          onClickSlot={onClickSlot}
          onClickDots={onClickDots}
        />
      </div>
    </BlockBoundary>
  )
}

export default QuickBookingRestCard
